(() => {
  const script = document.currentScript;
  const rootUrl = (script?.dataset.localizationRoot || '/').replace(/\/$/, '') || '/';

  const localizedPrefix = /^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i;
  const storefrontRoute = /^\/(?:products|collections|pages|blogs|cart|search|account|policies|gift_cards)(?=\/|$)/i;
  const attributes = ['href', 'data-product-url', 'data-url'];
  let queued = false;
  const pendingRoots = new Set();

  const localize = (value) => {
    if (!value) return value;
    const cleanValue = value.trim();
    if (/^(?:#|mailto:|tel:|javascript:|data:)/i.test(cleanValue)) return cleanValue;

    let parsed;
    try {
      parsed = new URL(cleanValue, window.location.origin);
    } catch (_error) {
      return cleanValue;
    }

    if (parsed.origin !== window.location.origin) return cleanValue;
    parsed.pathname = parsed.pathname.replace(/%20/gi, '');
    const hasLocalizedPrefix = localizedPrefix.test(parsed.pathname);
    const storefrontPath = hasLocalizedPrefix ? parsed.pathname.replace(localizedPrefix, '') || '/' : parsed.pathname;
    if (!storefrontRoute.test(storefrontPath)) return cleanValue;
    if (hasLocalizedPrefix) return `${parsed.pathname}${parsed.search}${parsed.hash}`;

    parsed.pathname = `${rootUrl}${parsed.pathname}`.replace(/\/{2,}/g, '/');
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  };

  const updateElement = (element) => {
    attributes.forEach((attribute) => {
      if (!element.hasAttribute?.(attribute)) return;
      const current = element.getAttribute(attribute);
      const localized = localize(current);
      if (localized !== current) element.setAttribute(attribute, localized);
    });
  };

  const scan = (root = document) => {
    if (root.nodeType === Node.ELEMENT_NODE) updateElement(root);
    root.querySelectorAll?.('a[href], [data-product-url], [data-url]').forEach(updateElement);
  };

  const scheduleScan = (root) => {
    if (root) pendingRoots.add(root);
    if (queued) return;
    queued = true;
    queueMicrotask(() => {
      queued = false;
      pendingRoots.forEach(scan);
      pendingRoots.clear();
    });
  };

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes') {
        scheduleScan(mutation.target);
        return;
      }
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) scheduleScan(node);
      });
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: attributes,
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
